import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { CONFIG } from './../services/config';
const INVENTIA_BASE_URL = CONFIG.INVENTIA_BASE_URL;
const { innerWidth, innerHeight } = window;
let processStepPersonalDataObserver = null;
let docType = null;

const WidgetInventia = ({ externalId, sessionId, setHideButton, sezioneHandler }) => {
  const [error, setError] = useState();
  const [verifiedInventia, setVerifiedInventia] = useState();
  const [hideButtonInventia, setHideButtonInventia] = useState(false);

  useEffect(() => {
    initializeWidget();
  }, [])

  const errorInventia = () => {
    Modal.error({
      title: 'Si è verificato un\'errore',
      content: 'Si prega di riprovare e seguire tutti gli step del processo',
      onOk: () => window.location.reload(),
    });
  };

  const checkStatusInventia = (info) => {
    const status = info.info.processStatus;
    if (status == 'PENDING' || status == 'pending' || status == 'COMPLETED' || status == 'completed') {
      setVerifiedInventia(true);
      setHideButton();
    } else {
      errorInventia();
    }
  };

  const initializeWidget = () => {
    window.widgetJs = document.createElement('script');
    window.widgetJs.type = 'text/javascript';
    window.widgetJs.id = 'recWidget';
    window.widgetJs.async = true;
    window.widgetJs.src = INVENTIA_BASE_URL + '/connect-server/widget/js/widget.js?v=' + Date.now();
    window.widgetJs.onload = configureWidget;

    window.resetInput = () => {
      var inputTypes = document.querySelectorAll("input[type=text]");
      inputTypes.forEach(function (item) {
        if (item.maxLength && item.maxLength > 0) {
          item.value = item.value.substring(0, item.maxLength);
        }
      });
    };

    window.initFormDemo = () => {
      var docType = document.querySelector("#DocumentTypeSelected");
      if (docType.value) {
        docType.parentElement.classList.add(docType.value);
      } else {
      }
    };

    window.top.addEventListener("onProcessStepChanged", (event) => {
      loadDocumentTypeSelectedField(event);
    })

    // window.top.addEventListener('onCallClosed', () => setError(true));

    window.top.addEventListener("onCallClosed", function (e) {

      if (/Android|iPhone/i.test(window.navigator.userAgent)) {
        const data = {
          sessionId,
          externalId
        }
        sezioneHandler(data);
        setTimeout(() => {
          window.location.reload();
        }, 3000)
      }
    }, false);

    window.top.addEventListener('onCallFailed', () => setError(true));
    window.top.addEventListener('onConnectionClosed', () => setError(true));
    window.top.addEventListener('onCallQueueTimeoutExpired', () => setError(true));
    window.top.addEventListener('onProcessClosed', checkStatusInventia);
    window.top.addEventListener('onWebWidgetHidden', () => setError(true));


    document.head.prepend(window.widgetJs);
  };

  function loadDocumentTypeSelectedField(event) {
    switch (event.info.step) {
      case "personal-data":
        checkDocumentType();
        break;
    }
  }

  async function checkDocumentType() {
    let res = await fetch(INVENTIA_BASE_URL + '/connect-server-multitenant/api/baz/baz/checkDocumentType?externalId=' + externalId, {
      method: 'GET',
    }).then(function (response) {
      if (response.status !== 200) {
        throw new Error(response.statusText);
      }
      return response.json();
    }).catch(e => {
    });

    switch (res.DocumentTypeSelected) {
      case "IT_PASSPORT":
        document.getElementById('ProvinceOfBirthLabel').remove();
        document.getElementById('CountryOfBirthLabel').remove();
        document.getElementById('IssuingPlaceLabel').remove();
        document.getElementById('AddressStreetLabel').remove();
        document.getElementById('AddressLocalityLabel').remove();
        document.getElementById('AddressProvinceLabel').remove();
        break;
      case "IT_DL_CARD":
        document.getElementById('SexLabel').remove();
        document.getElementById('CountryOfBirthLabel').remove();
        document.getElementById('NationalityLabel').remove();
        document.getElementById('IssuingPlaceLabel').remove();
        document.getElementById('AddressStreetLabel').remove();
        document.getElementById('AddressLocalityLabel').remove();
        document.getElementById('AddressProvinceLabel').remove();
        break;
      case "IT_ID_PAPER":
        document.getElementById('SexLabel').remove();
        document.getElementById('ProvinceOfBirthLabel').remove();
        document.getElementById('CountryOfBirthLabel').remove();
        document.getElementById('AddressProvinceLabel').remove();
        break;
      case "IT_ID_CIE":
        document.getElementById('AddressProvinceLabel').remove();
        break;
      case "IT_ID_CIE30":
        document.getElementById('CountryOfBirthLabel').remove();
        document.getElementById('IssuerLabel').remove();
        break;
    }
  }

  function initFormClasses() {
    var docTypeElement = document.querySelector("#DocumentTypeSelected");

    if (!docTypeElement) {
      return;
    }

    docTypeElement.value = docType;
    docTypeElement.parentElement.classList.add(docType);
  }

  function configureProcessStepPersonalDataObserver() {
    const elemToObserve = document.getElementsByTagName("body")[0];
    const classToObserve = "process-step-personal-data";
    let prevClassState = null;

    if (elemToObserve) {
      prevClassState = elemToObserve.classList.contains(classToObserve);
    }

    processStepPersonalDataObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName == "class") {
          var currentClassState = mutation.target.classList.contains(
            classToObserve
          );
          if (prevClassState !== currentClassState) {
            // debugger;
            prevClassState = currentClassState;
            if (currentClassState) {
              // class added
              initFormClasses();
            } else {
              // class removed - do nothing
            }
          }
        }
      });
    });
    processStepPersonalDataObserver.observe(elemToObserve, { attributes: true });
  }

  const configureWidget = () => {
    window.connectwidget.configure({
      // entrypoint: "widget",
      locale: "it",
      reloadHostPageInIFrame: false,
      positioning: {
        // defaultWidgetWidth: window.screen.availWidth,
        // defaultWidgetHeight: 604,
        // defaultWidgetWidthOnRightClosed: 600,
        // positionY: 0,
        // draggable: false,
        resizeable: false,
        // fullscreen: true,

      },
      disableRemoteVideo: true,
      // customCss: customStyle, // not working
      // customCss: INVENTIA_BASE_URL + "/connect-server/widget/css/widget-automa.css",
      customCss: process.env.PUBLIC_URL + "/self-id/widget-automa.css",
      // customMobileCss: INVENTIA_BASE_URL + "/connect-server/widget/common/css/customer.css",
      customMobileCss: process.env.PUBLIC_URL + "/self-id/customer.css",
      disableReloading: true,
      closeWidgetAfterCallClosed: true,
      onOperatorNotAvailable: (e) => console.log(e),
      onCallQueueTimeout: (e) => console.log(e),
      onBrowserNotCompatible: (e) => console.log(e),
      onCallExtabilished: (e) => console.log(e),
      onCallClosed: (e) => console.log(e),
    });

    configureProcessStepPersonalDataObserver();
  };

  const handleStartCall = () => {
    // console.log(sessionId, externalId);
    setHideButtonInventia(true);
    const processId = "SelfId";
    const extension = "/automa";
    const autoStartCall = true;
    const callType = "video";
    const advertisingUrl = null;
    const useApp = null;
    const callData = null;
    const disableAudio = false;
    const disableRemoteVideo = true;

    window.connectwidget.startCall(
      sessionId,
      processId + ":" + externalId,
      extension,
      autoStartCall,
      callType,
      advertisingUrl,
      useApp,
      callData,
      disableAudio,
      disableRemoteVideo
    );
  };

  return (
    <div>
      {!verifiedInventia &&
        <div>
          <div
            style={{ fontFamily: 'Poppins-SemiBold', fontSize: 18, color: '#707070', width: '80%', marginBottom: 20 }}>
            Procederemo ora alla verifica della tua identità. Tieni a portata di mano un documento d'identità e consenti l’accesso alla camera se ti verrà richiesto. Il processo durerà pochi minuti.
          </div>
          <div
            style={{ fontFamily: 'Poppins-Regular', fontSize: 16, color: '#707070', width: '80%' }}>
            Il tuo documento d'identità e la tua tessera sanitaria con codice fiscale devono essere validi e privi di qualsiasi pellicola protettiva o impurità.
          </div>
        </div>}
      {verifiedInventia &&
        <div>
          <div
            style={{ fontFamily: 'Poppins-SemiBold', fontSize: 18, color: '#707070', width: '80%', marginBottom: 20 }}>
            Il processo di verifica è terminato
          </div>
          <div
            style={{ fontFamily: 'Poppins-Regular', fontSize: 16, color: '#707070', width: '80%' }}>
            Prosegui per visualizzare lo stato della tua pratica e visualizzare i tuoi documenti!
          </div>
        </div>}
      {!verifiedInventia && !hideButtonInventia &&
        <div
          // style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 200, marginTop: 100 }}
          style={{ position: 'fixed', right: '8%', bottom: 50, zIndex: 10 }}
        >
          <Button
            type="primary"
            style={{ backgroundColor: '#2574F2', height: innerWidth < 500 ? 35 : 50, width: innerWidth < 500 ? 147 : 200, borderRadius: 6 }}
            onClick={() => handleStartCall()}
          >
            <div style={{ fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 13 : 18 }}>
              AVVIA LA VERIFICA
            </div>
          </Button>
        </div>
      }

    </div>
  );
};

export default WidgetInventia;
